import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-show-progress',
  templateUrl: './show-progress.component.html',
  styleUrls: ['./show-progress.component.scss']
})
export class ShowProgressComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
